<template>
  <div class="shareReport">
    <h1>Report Share</h1>
    <div class="ellipsis info">
      <em>{{ isShared ? shareData.title : reportDatum.title }}</em>
      <a :href="reportDatum.url" target="_blank"
        :title="`${reportDatum.url} : ${$t('common.openNewWindow')}`">{{ reportDatum.url }}</a>
    </div>
    <table>
      <colgroup>
        <col :width="isShared ? 110 : 230" />
        <col width='*' />
      </colgroup>
      <template v-if="isShared">
        <tr>
          <th>{{ $t('shareReport.shareLink') }}</th>
          <td ref="shareUrl">
            {{ shareData.token | reportShareUrl }}
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <th>{{ $t('shareReport.pageName') }}</th>
          <td>
            <span v-if="isEditMode">
              <input type="text" name="" :title="$t('shareReport.pageName')" maxlength="50" ref="title"
                v-model.trim="model.title" />
              <button type="button" class="btn_write"
                @click="onEditModeToggle"><span class="haze">수정</span></button>
            </span>
            <span v-else>
              <span>{{ model.title }}
                <button type="button" class="btn_write"
                  @click="onEditModeToggle"><span class="haze">수정</span></button></span>
            </span>
            <span class="wrong" v-if="errors.title">* {{ $t(errors.title) }}</span>
          </td>
        </tr>
        <tr>
          <th>{{ $t('shareReport.setPassword') }}</th>
          <td>
            <input type="password" name="" :title="$t('shareReport.password')" v-model="model.password"
              @keyup.enter="onShareClick" />
            <p class="description">
              Please enter a password combination of alphabet, numeric, special character with more than 8 characters long. More than 4 consecutive characters are not allowed.
            </p>
            <span class="wrong" v-if="errors.password">* {{ $t(errors.password) }}</span>
          </td>
        </tr>
      </template>
    </table>
    <p class="btns">
      <button v-if="isShared" type="button" class="btn_2"
        @click="onCopyLinkClick">{{ $t('shareReport.copyLink') }}</button>
      <button v-else type="button" class="btn_2"
        @click="onShareClick">{{ $t('shareReport.createLink') }}</button>
      <button type="button" class="btn_3" @click="onCancelClick">{{ $t('common.cancel') }}</button>
    </p>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard'
import reportShareApi from '@/api/report-share'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'ReportShare',
  mixins: [ajaxHandlerMixin],
  props: ['report', 'shareData'],
  data () {
    return {
      isEditMode: false,
      errors: {},
      model: {
        reportId: null,
        title: null,
        password: null
      }
    }
  },
  computed: {
    reportDatum () {
      return this.report.ReportDatum
    },
    isShared () {
      return !!this.shareData
    }
  },
  created () {
    this.model.title = this.reportDatum.title
    this.model.reportId = this.report.mainReport || this.report.id
  },
  methods: {
    onShareClick () {
      reportShareApi.add(this.model).then(response => {
        this.$emit('onReportShare', response.data)
      }).catch(this.handleAjaxError)
    },
    onCancelClick () {
      this.$emit('onCancelClick')
    },
    onCopyLinkClick () {
      const copySuccess = copy(this.$refs.shareUrl.textContent.trim())

      if (copySuccess) {
        this.$emit('onShareUrlCopy')
      } else {
        console.error('copy url failed')
      }
    },
    onEditModeToggle () {
      this.isEditMode = !this.isEditMode

      if (this.isEditMode) {
        this.$nextTick(() => {
          this.$refs.title.focus()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shareReport {
  position: fixed;
  top: 200px;
  left: 25%;
  right: 25%;
  min-width: 300px;
  padding: 40px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  h1 {
    line-height: 40px;
    color: #294f75;
    font-size: 16px;
  }

  .info {
    position: relative;
    padding: 0 20px 0 20px;
    line-height: 40px;
    background: #efefef;

    * {
      font-size: 12px;
    }

    a:hover,
    a:focus {
      color: #4d627b;
      border-bottom: 1px solid #4d627b;
    }
  }

  table {
    margin-top: 20px;
    font-size: 13px;

    th {
      text-align: right;
      vertical-align: top;
      line-height: 40px;
      padding-right: 20px;
    }

    td {
      position: relative;
      line-height: 40px;
      padding: 0 10px 35px 0;

      button {
        vertical-align: middle;
      }

      .select {
        width: 100%;
      }

      input {
        width: 70%;
      }

      .wrong {
        position: absolute;
        left: 0;
        bottom: 15px;
        font-size: 12px;
        font-weight: normal;
        color: #ec0047;
        white-space: nowrap;
      }

      .description {
        display: block;
        margin: 5px 5px 0;
        font-size: 12px;
        color: #999999;
        width: 300px;
      }
    }
  }

  .btns {
    padding-top: 10px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportShare.vue